import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import SEO from '../components/SEO';
import "./Contacto.css";

const Contacto = () => {
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      // Enviar os dados para o backend, incluindo a língua atual
      await axios.post('/api/contact', {
        ...formData,
        language: i18n.language // Envia 'pt', 'en', 'es', etc.
      });

      setStatus({ type: 'success', message: t('pages.contact.successMessage') });
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('Erro ao enviar mensagem:', error);
      setStatus({ type: 'error', message: t('pages.contact.errorMessage') });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contacto-container">
      <SEO titleKey="seo.contact.title" descriptionKey="seo.contact.description" />
      <div className="contacto-content">
        <h1>{t('pages.contact.title')}</h1>
        <p>{t('pages.contact.subtitle')}</p>
        <p className="beta-message">{t('pages.contact.betaMessage')}</p>

        <form onSubmit={handleSubmit} className="contacto-form">
          <div className="form-group">
            <label htmlFor="name">{t('pages.contact.nameLabel')}</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">{t('pages.contact.emailLabel')}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">{t('pages.contact.messageLabel')}</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          {status.message && (
            <div className={`status-message ${status.type}`}>
              {status.type === 'success' ? (
                <span className="icon">✓</span>
              ) : (
                <span className="icon">⚠</span>
              )}
              {status.message}
            </div>
          )}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? (t('common.sending') || 'A enviar...') : t('pages.contact.submitButton')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contacto;

